import styled from 'styled-components';

export const StyledChronometer = styled.div`
  position: absolute;
  z-index: 200;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;

  .elapsed-time {
    width: 100px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    box-shadow: 3px 5px 5px -3px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 4px 4px;
    border: solid 1px #e0e0e0;
    border-top: none;
    background-color: #ffffffbb;
    height: 23px;
    * {
      position: relative;
      font-size: 20px;
      line-height: 1em;
      width: 1.5em;
      text-align: center;
    }
    .minutes::after {
      content: ':';
      right: -0.1em;
      position: absolute;
    }
  }
`;
